import * as React from "react";

import { IconEllipsisV } from "../icons/IconEllipsisV";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonOverflowV: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonOverflowV.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconEllipsisV fixedWidth />
        </MprcIconButton>
    );
};
